/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Grid, Typography, TextField, InputAdornment, Button, DialogTitle, DialogActions, Divider, IconButton, Backdrop, CircularProgress } from '@mui/material'
import LogoPTT from "../../../assets/Image/logo-ptt.png";
import useMediaQuery from '@mui/material/useMediaQuery';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import { AccountCircle, LockRounded } from "@mui/icons-material";
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { makeStyles } from '@mui/styles';
import { AlertTitle, AxiosPost, OnFocus, ResultAPI } from 'service/CommonFunction/TS_function';
import { AuthToken, currentLanguage, RedirectPath } from 'service/CommonFunction/AxiosConfig';
import { useNavigate } from 'react-router-dom';
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { i18n } from 'i18n';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import SelectFormItem from 'components/Common/ElementInForm/SelectFormItem_new';
import secureLocalStorage from 'react-secure-storage';
const i18nField = 'entities.DialogLogin.fields';


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const arrUserType = [
    { label: "Customer User", value: "C" },
    { label: "Internal User", value: "I" },
]

const DialogLogin = (props) => {

    const { open, setOpen, setIsPopUpRegister, setIsPopUpForgot } = props;

    const navigate = useNavigate();
    const [IsTypePass, setIsTypePass] = useState(true)
    const [openBackDrop, setOpenBackDrop] = React.useState(false);

    const [Username, setUsername] = useState("");
    const [Password, setPassword] = useState("");
    const [MessageError, setMessageError] = useState("")

    const schema = yup.object().shape({
        oLoginMode: yupFormSchemas.object(`Login Mode`, { required: true }),
    });

    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        if (open) {
            form.setValue("oLoginMode", { label: "Customer User", value: "C" })
            setUsername("");
            setPassword("");
            setTimeout(() => {
                OnFocus("txtUsername", "btnLogin");
                OnFocus("txtPassword", "btnLogin");
            }, 2000);
        }
    }, [open])

    const onGotoLoginAD =()=>{
        let sSiteAD = process.env.REACT_APP_LOGINAD;
        // navigate(sSiteAD)  //ต่อพาธ
        let anchor = document.createElement("a");
        anchor.href = sSiteAD;
        anchor.click();
    }

    const onGetLinkAndGotoLink =()=>{
        let sLinkTo = secureLocalStorage.getItem("LinkTo") as string;
        secureLocalStorage.removeItem("LinkTo");
        secureLocalStorage.removeItem("sUserType");
        if(sLinkTo && sLinkTo != "")
        {
            let anchor = document.createElement("a");
            anchor.href = sLinkTo;
            anchor.click();
        }
        else
        {
            navigate("/Home")
            window.location.reload();
        }
    }

    const onLogin = () => {
        let IsCheckPass = true;
        let sMessage = "";
        if (Username === "" && Password === "") {
            sMessage = currentLanguage() == "en" ? "Please enter Username and Password" : "กรุณากรอกชื่อผู้ใช้งานและรหัสผ่าน"
            IsCheckPass = false;
        } else if (Username === "") {
            sMessage = currentLanguage() == "en" ? "Please enter Username" : "กรุณากรอกชื่อผู้ใช้งาน"
            IsCheckPass = false;
        } else if (Password === "") {
            sMessage = currentLanguage() == "en" ? "Please enter Password" : "กรุณากรอกรหัสผ่าน"
            IsCheckPass = false;
        } else {
            sMessage = "";
        }
        setMessageError(sMessage)
        if (IsCheckPass) {
            let Paramlogin = {
                "sUsername": Username,
                "sPWD": Password,
                "sUserType": form.getValues("oLoginMode")?.value
            }
            setOpenBackDrop(true)
            AxiosPost("Authentication/Login", Paramlogin, (res) => {
                setOpenBackDrop(false)
                ResultAPI(res, null, () => {
                    if (res.result?.token) {
                        setOpen(!open)
                        AuthToken.set(res.result.token)
                        onGetLinkAndGotoLink()
                        // var currentPath = RedirectPath.get() ?? null
                        // if (currentPath) {
                        //     RedirectPath.set(null)
                        //     let anchor = document.createElement("a");
                        //     anchor.href = currentPath.toString();
                        //     anchor.click();
                        // } else {
                        //     navigate("/Home")
                        //     window.location.reload();
                        // }
                    }
                    else if (res.Message != "" && res.Message != null) {
                        if (res.Message == "Not Found Company GBU") {
                            setMessageError(currentLanguage() == "en" ? "Not Found Company GBU" : "ไม่พบข้อมูลบริษัทใน GBU")
                        } else if (res.Message == "No Permission PIS") {
                            setMessageError(currentLanguage() == "en" ? "No permission to access the system GBU" : "ไม่มีสิทธิ์เข้าใช้งานระบบ uVoice")
                        } else if (res.Message != null) {
                            setMessageError(res.Message)
                        } else {
                            setMessageError(currentLanguage() == "en" ? "Password is incorrect" : "รหัสผ่านไม่ถูกต้อง")
                        }
                        // return false;
                    }
                })
            }, (err) => {
                setMessageError(err.response.data.Message)
            }, null);
        }

    }

    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                onClose={() => { setOpen(!open) }}
                maxWidth={"xs"}
                fullWidth={true}
                aria-describedby="form-sign-in"
            >
                <DialogTitle>
                    <Grid container justifyContent="center" alignItems="center">
                        <Grid item>
                            <img
                                alt={"PTT Logo"}
                                style={{ objectFit: "contain", width: '8rem', }}
                                width="50px"
                                src={LogoPTT}
                            />
                            <span style={{ fontSize: '1.4rem', marginTop: '20px' }}><b>Voice of Customer</b></span>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent style={{ paddingBottom: '0', paddingTop: '8px' }}>
                    <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12}>
                            <FormProvider {...form}>
                                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                                    <Grid item xs={12} sm={10}>
                                        <SelectFormItem
                                            name="oLoginMode"
                                            options={arrUserType}
                                            label={'Login Mode'}
                                            required={false}
                                            IsRadius={true}
                                            onChange={() => { setMessageError("") }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={10}>
                                        <TextField
                                            size="small"
                                            id="txtUsername"
                                            value={Username}
                                            fullWidth={true}
                                            // label={"ชื่อผู้ใช้งาน/Username"}
                                            placeholder={i18n(`${i18nField}.sUserName`)}
                                            sx={{ backgroundColor: "rgba(255,255,255,0)" }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <AccountCircle />
                                                    </InputAdornment>
                                                ),
                                                sx: {
                                                    borderRadius: "50rem"
                                                },
                                            }}
                                            onChange={(e) => { setMessageError(""); setUsername(e.target.value) }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={10}>
                                        <TextField
                                            id="txtPassword"
                                            size="small"
                                            fullWidth={true}
                                            value={Password}
                                            placeholder={i18n(`${i18nField}.sPassword`)}
                                            type={!IsTypePass ? "text" : "password"}
                                            sx={{ backgroundColor: "rgba(255,255,255,0)" }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <LockRounded />
                                                    </InputAdornment>
                                                ),
                                                endAdornment: (
                                                    <InputAdornment position="start">
                                                        <IconButton
                                                            style={{ padding: '0px' }}
                                                            onClick={(() => { setIsTypePass(!IsTypePass) })}
                                                        >
                                                            {IsTypePass ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                                sx: {
                                                    borderRadius: "50rem"
                                                },
                                            }}
                                            onChange={(e) => { setMessageError(""); setPassword(e.target.value) }}
                                        />
                                    </Grid>
                                    {
                                        MessageError !== ""
                                            ?
                                            <Grid item xs={12}>
                                                <Typography style={{ color: 'red', textAlign: 'center' }}>{MessageError}</Typography>
                                            </Grid>
                                            : null
                                    }
                                    <Grid item>
                                        <Button
                                            id="btnLogin"
                                            style={{ textTransform: 'none', minWidth: '12rem', borderRadius: '25px' }}
                                            onClick={() => onLogin()}
                                            variant="contained"
                                        >
                                            {i18n(`${i18nField}.sLogin`)}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </FormProvider>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider>{i18n(`${i18nField}.or`)}</Divider>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <Button
                                variant="outlined"
                                size="medium"
                                fullWidth
                                style={{ backgroundColor: '#1773ea', color: '#ffffff', borderRadius: '25px' }}
                                // startIcon={<SmsOutlinedIcon style={{ color: '#ffffff' }} />}
                                onClick={() => {onGotoLoginAD()}}
                            >
                                Login PTT AD
                            </Button>
                        </Grid>
                        <Grid item xs={12}>

                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ padding: '16px' }}>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                        <Grid item >
                            <div
                                style={{ width: '100%', color: 'blue', cursor: 'pointer' }}
                                onClick={() => {
                                    setOpen(false);
                                    setIsPopUpRegister(true)
                                }}
                            >
                                {i18n(`${i18nField}.sSignup`)}
                            </div>
                        </Grid>
                        <Grid item >
                            <div
                                style={{ width: '100%', color: 'blue', cursor: 'pointer' }}
                                onClick={() => {
                                    setOpen(false);
                                    setIsPopUpForgot(true)
                                }}
                            >
                                {i18n(`${i18nField}.sForgotPassword`)}
                            </div>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            <Backdrop
                sx={{ color: '#fff', zIndex: 99999 }}
                open={openBackDrop}
            >
                <div className="spinner">
                    <span className="ball-1"></span>
                    <span className="ball-2"></span>
                    <span className="ball-3"></span>
                    <span className="ball-4"></span>
                    <span className="ball-5"></span>
                    <span className="ball-6"></span>
                    <span className="ball-7"></span>
                    <span className="ball-8"></span>
                </div>
            </Backdrop>
        </>
    )
}

export default DialogLogin